export const server = {
  isStaging: process.env.NEXT_PUBLIC_SERVER === "staging",
  isDevelopment: process.env.NEXT_PUBLIC_SERVER === "development",
  isProduction: process.env.NEXT_PUBLIC_SERVER === "production",
};

export const firebase = {
  
  projectId: (() => {
    if(server.isDevelopment) return "juggernaut-dev-7f5dd";
    if(server.isStaging) return "juggernaut-staging-1";
    if(server.isProduction) return "juggernaut-production";
    return ''
  })(),

  clientEmail: (() => {
    if(server.isDevelopment) return "firebase-adminsdk-c7yvf@juggernaut-dev-7f5dd.iam.gserviceaccount.com"
    if(server.isStaging) return "firebase-adminsdk-7kgt1@juggernaut-staging-1.iam.gserviceaccount.com"
    if(server.isProduction) return "firebase-adminsdk-j5x0i@juggernaut-production.iam.gserviceaccount.com"
    return ''
  })(),

  apiKey: (() => {
    if(server.isDevelopment) return "AIzaSyBjvbntReWY8D1qOBfiDX83U4f4EYWnGk0";
    if(server.isStaging) return "AIzaSyBGQgGwLg7RwtTpnAA4gXJMI0s6-LoThUE";
    if(server.isProduction) return "AIzaSyC-LKXUXEoLWRCusDJ54ZlcdqL3mx_FZzo";
    return ''
  })(),

  authDomain: (() => {
    if (server.isDevelopment) return "juggernaut-dev-7f5dd.firebaseapp.com";
    if (server.isStaging) return "juggernaut-staging-1.firebaseapp.com";
    if (server.isProduction) return "juggernaut-production.firebaseapp.com";
    return ''
  })()
}